import {
  USER_LOGIN_FAILED,
  USER_LOGIN_REQ,
  USER_LOGIN_RESET,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT_REQ,
} from "../Constants/LoginConstant";

export const LoginReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case USER_LOGIN_REQ: {
      return { Login_Loading: true };
    }

    case USER_LOGIN_SUCCESS: {
      return {
        Login_Loading: false,
        accTkn: payload.data.accesstoken,
        UserDet: payload.data?.Result[0],
      };
    }
    case USER_LOGIN_FAILED: {
      return { Login_Loading: false, Login_Error: payload };
    }
    case USER_LOGIN_RESET: {
      return {};
    }

    case USER_LOGOUT_REQ: {
      localStorage.removeItem("accTkn");
      return { Login_Loading: false, Login_data: null, Login_error: false };
    }

    default:
      return state;
  }
};

export const Sidebar_Reducer = (
  state = { sidebar: false },
  { type, payload }
) => {
  switch (type) {
    case "SIDEBAR_OPEN": {
      return { sidebar: payload };
    }

    default:
      return state;
  }
};
